<template>
  <vx-card :title="`${$route.query.role || ''} Permissions`">
    <template v-if="skeleton">
      <a-skeleton v-for="n in 5" :key="n" active avatar />
    </template>
    <template v-else>
      <a-button type="primary" ghost @click="backToUser" class="back-user">
        Close
      </a-button>
      <a-tree
        checkable
        :tree-data="permissions"
        :default-checked-keys="defaultPermission"
        @select="onSelect"
        @check="onCheck"
      />
      <a-button
        type="primary"
        :loading="loading"
        class="mt-10"
        @click="handleRolePermission"
        >Save</a-button
      >
    </template>
  </vx-card>
</template>
<script>
import axios from "@/axios";
import mixin from "@/views/mixin/mixin";

export default {
  mixins: [mixin],
  props: {
    getUrl: {
      type: String,
    },
    submitUrl: {
      type: String,
    },
    hasRoleId: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data() {
    return {
      skeleton: false,
      loading: false,
      permissions: [],
      defaultPermission: [],
    };
  },
  methods: {
    onSelect(selectedKeys) {
      //console.log("selected", selectedKeys);
    },
    onCheck(checkedKeys) {
      this.defaultPermission = checkedKeys;
    },
    firstLetterUppercase(title,index = 0) {
      if (title[index].includes('-')) {
        const word = title[index].split('-')
        return this.firstLetterUppercase(word) + ' ' + word[1]
      }
      return title[index].charAt(0).toUpperCase() + title[index].slice(1)
    },
    labelPermission(title) {
      if (title.includes('-')){
        const splitLabel = title.split('-')
        return this.firstLetterUppercase(splitLabel) + ' ' + splitLabel[1]
      }
      return title[0].charAt(0).toUpperCase() + title.slice(1)
    },
    permissionLabelChildren(word,field) {
      const splitWord = word.split('.')
      switch (field){
        case 'calendar':{
          return splitWord[2] === 'get' ? 'Details' : this.firstLetterUppercase(splitWord,2)
        }
        case 'activity':{
          const labels = {
            'expense-entry': 'Expense entry',
            'time-entry'   : 'Time entry',
            'category'     : 'category',
            'get'          : 'details'
          }
          return splitWord.includes('category') ?
            labels[splitWord[1]] + ' ' + labels[splitWord[2]] + ' ' + (labels[splitWord[3]] || splitWord[3])
            : labels[splitWord[1]] + ' ' + (labels[splitWord[2]] || splitWord[2])
        }
        case 'billing':{
          const labels = {
            'fund'         : 'Fund',
            'fund-request' : 'Fund request',
            'category'     : 'category',
            'get'          : 'details'
          }
          return splitWord.length === 3 ? labels[splitWord[1]] + ' ' + (labels[splitWord[2]] || splitWord[2]) : 'Billing ' + (labels[splitWord[1]] || splitWord[1])
        }
        case 'communication':{
          const typeLog = splitWord[1].split('-')
          return this.firstLetterUppercase(typeLog) + ' ' + typeLog[1] + ' ' + (splitWord[2] === 'get' ? 'details' : splitWord[2])
        }
        case 'setting':{
          const labels = {
            'pracctice-area'                : 'practice area',
            'manage-users-and-permissions'  : 'users and permissions',
            'recover-bin'                   : 'Recovery',
          }
          return this.firstLetterUppercase(splitWord,1) + ' ' + (labels[splitWord[2]] || splitWord[2])
        }
        case 'report':{
          const word = this.firstLetterUppercase(splitWord)
          return splitWord.length === 3 ? this.labelPermission(splitWord[2]) : word === 'Contact' ? 'Client' : word
        }
        default: {
          return splitWord[1] === 'get' ? 'Details' : this.firstLetterUppercase(splitWord,1)
        }
      }
    },
    async getAllPermissions() {
      try {
        this.skeleton     = true;
        const url         = this.getUrl || `permissions/role-permissions/${this.$route.params.id}`;
        const { data }    = await axios.get("permissions/");
        const permissions = await axios.get(url);
        const dataSource  = [...new Set(data)];
        this.defaultPermission = permissions.data;
        const fields = [
          'matter',
          'task',
          'contact',
          'note',
          'document',
          'calendar',
          'activity',
          'bank-account',
          'billing',
          'communication',
          'setting',
          'report'
        ]
        const list = fields.map((field) => {
          const items = dataSource.filter((word) => {
            const a = word.split(".");
            return field === 'report' ? word.includes('report') : a[0] === field && !word.includes("report")
          }).map(permission => ({
            title: this.permissionLabelChildren(permission, field),
            key: permission
          }));
          return {list: items, title: field}
        }).map(items => ({
            title: this.labelPermission(items.title),
            key: items.title,
            children: items.list.map(item => ({
              key: item.key,
              title: item.title
            }))
          }
        ))
        this.permissions = list
      } catch (e) {
        await this.$message.error("Server Error");
        this.$router.back()
        throw new Error(e);
      } finally {
        this.skeleton = false;
      }
    },
    async handleRolePermission() {
      if (this.$route.params.id) {
        try {
          this.loading = true;
          const url =
            this.submitUrl ||
            `permissions/permission-assign/${this.$route.params.id}/`;
          await axios.post(url, {
            permissions: this.defaultPermission.filter((x) => x.includes(".")),
          });
          this.$message.success("Permission granted.");
        } catch (e) {
          this.$message.error("Error applying permission.");
          throw new Error(e);
        } finally {
          this.loading = false;
        }
      }
    },
    backToUser() {
      this.$router.back();
    },
  },
  mounted() {
    this.getAllPermissions();
  },
};
</script>

<style>
.back-user {
  border-radius: 3px !important;
  margin-left: auto;
  text-align: right;
  display: block;
}
</style>
